import { toDate } from '../../utils';

export const bookingFormFields = {
    lastName: {
        id: 'lastName',
        type: 'text',
        required: true,
        label: 'Фамилия',
        validationType: 'fio',
    },
    firstName: {
        id: 'firstName',
        type: 'text',
        required: true,
        label: 'Имя',
        validationType: 'fio',
    },
    middleName: {
        id: 'middleName',
        type: 'text',
        required: true,
        label: 'Отчество',
        validationType: 'fioOrDash',
    },
    phone: {
        id: 'phone',
        type: 'phone',
        required: true,
        validationType: 'phone',
        label: 'Телефон',
    },
    birthDate: {
        id: 'birthDate',
        type: 'date',
        required: true,
        label: 'Дата рождения',
        validationType: 'date_less',
    },
    sex: {
        id: 'sex',
        type: 'radio',
        required: true,
        metaData: [
            { id: 'female', name: 'Жен' },
            { id: 'male', name: 'Муж' },
        ],
        title: 'Пол',
        validationType: 'radio',
    },
    email: {
        id: 'email',
        type: 'text',
        label: 'Email',
        validationType: 'email',
        noFormatting: true,
    },
    clientNote: {
        id: 'clientNote',
        type: 'textarea',
        label: 'Примечание',
        validationType: 'text',
    },
};

export const getAgeOfPatient = (birthdate) => {
    const date = toDate(birthdate);
    return Math.floor((new Date() - date.getTime()) / 3.15576e10); // the length of a year is 365 days
    // and 6 hours which is 0.25 day which are 3.15576e+10 milliseconds (365.25 * 24 * 60 * 60 * 1000) respectively.
};

// eslint-disable-next-line consistent-return
export const ageLimitsAreKept = ({
    patientAge, isDoctorTreatAdults, isDoctorTreatChildren, childrenAge, childrenAgeTo = 18, adultAge = 18, adultAgeTo = 999,
}) => {
    const isDoctorTreatOnlyAdults = isDoctorTreatAdults && !isDoctorTreatChildren;
    const isDoctorTreatOnlyChildren = !isDoctorTreatAdults && isDoctorTreatChildren;
    const isDoctorTreatAllAges = isDoctorTreatAdults && isDoctorTreatChildren;
    if (isDoctorTreatOnlyAdults) {
        return patientAge >= adultAge && patientAge <= adultAgeTo;
    }
    if (isDoctorTreatOnlyChildren) {
        return patientAge <= childrenAgeTo && patientAge >= childrenAge;
    }
    if (isDoctorTreatAllAges) {
        return patientAge >= childrenAge;
    }
};
